import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'coinSymbol'})
export class CoinSymbolPipe implements PipeTransform {

    coinSymbolMap = {
        '208': `kr`,
        '752': `kr`,
        '578': `kr`,
        '840': `$`,
        '124': `$`,
        '036': `$`,
        '756': `Fr`,
        '392': `¥`,
        '826': `£`,
        '710': `R`,
        '985': `zł`,
        '978': `€`,
    };

    transform(value: string): string {
        if (!value) {
            return '';
        }

        return this.coinSymbolMap[value];
    }
}
